import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  API_CHARGE_ASSIGNMENT,
  API_CUSTOMER_CONFIGURABLE_MERCHANTS,
} from "../../utils/apis";
import { createViewEdit, getForm, getRegister } from "../../utils/helpers";
import { URL_CHARGE_ASSIGNMENT } from "../../utils/urls";
import useGet from "../common/useGet";

const url = URL_CHARGE_ASSIGNMENT;

export const useChargeAssignment = () => {
  const tableColumns = () => [
    {
      id: "merchant_name",
      header: "Merchant Name",
      filter: {},
    },
    {
      id: "merchant_number",
      header: "Merchant Number",
      filter: {},
    },
    {
      id: "charge_customer_vat",
      header: "Charge Customer VAT",
      filter: {},
    },
    {
      id: "charge_customer_yoya_charge",
      header: "Charge Customer Yoya Charge",
      filter: {},
    },
    {
      id: "charge_customer_partner_charge",
      header: "Charge Customer Partner Charge",
      filter: {},
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        charge_customer_vat: <BooleanTags status={item?.charge_customer_vat} />,
        charge_customer_yoya_charge: (
          <BooleanTags status={item?.charge_customer_yoya_charge} />
        ),
        charge_customer_partner_charge: (
          <BooleanTags status={item?.charge_customer_partner_charge} />
        ),
        actions: <FormActions actions={[...createViewEdit(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Charge Assignment Details",
          fields: {
            merchant_number: item?.merchant_number,
            charge_customer_vat: (
              <BooleanTags status={item?.charge_customer_vat} />
            ),
            charge_customer_yoya_charge: (
              <BooleanTags status={item?.charge_customer_yoya_charge} />
            ),
            charge_customer_partner_charge: (
              <BooleanTags status={item?.charge_customer_partner_charge} />
            ),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);
  const tableTitle = "Charge Assignment";

  return {
    tableColumns,
    tableData,
    viewData,
    formRoute,
    tableTitle,
  };
};

export const useChargeAssignmentForm = () => {
  const {
    loadData: loadMerchantNumber,
    loading: loadingMerchantNumber,
    data: merchantNumberData,
    error,
  } = useGet();

  useEffect(() => {
    loadMerchantNumber({ api: API_CUSTOMER_CONFIGURABLE_MERCHANTS });
  }, []);

  const sections: any = [
    {
      title: "Charge Assignment Details",
      fields: [
        {
          field_name: "merchant_number",
          type: "select",
          props: {
            required: true,
          },
          options_data: merchantNumberData?.map((item: any) => {
            return {
              id: item?.id,
              name: item?.name,
            };
          }),
        },
        {
          field_name: "charge_customer_vat",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "charge_customer_yoya_charge",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "charge_customer_partner_charge",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
      ],
    },
  ];
  const redirect = getRegister(url);

  return {
    sections,
    redirect,
    loadingMerchantNumber,
    merchantNumberData,
    error,
  };
};

export const submitChargeAssignment = (payload: any, id: string | number) => {
  if (id) {
    return {
      api: `${API_CHARGE_ASSIGNMENT}${id}/`,
      params: {
        ...payload,
      },
    };
  }

  //   CREATE
  return {
    api: `${API_CHARGE_ASSIGNMENT}`,
    params: {
      ...payload,
    },
  };
};
